import {
  Anchor,
  Badge,
  Box,
  COLOR_PALETTE,
  Ellipsis,
  Group,
  OptimizeImage,
  Stack,
  desktopFirstMediaQuery,
} from '@inflearn/ds-react';
import type { ReactNode } from 'react';
import { GiftStatus } from '../../../../../pages/my/gifts/sent';
import { GiftInfoRow } from '../common/GiftInfoRow';
import { GiftItemHeader } from '../common/GiftItemHeader';

export interface ReceivedGiftItemProps {
  id: number;
  receivedDate: string;
  courseTitle: string;
  senderName: string;
  courseDescription01?: ReactNode;
  courseDescription02?: ReactNode;
  status: GiftStatus;
  courseImageUrl?: string;
  detailURL: string;
  courseDetailURL: string;
}

const StatusBadge = ({ status }: { status: ReceivedGiftItemProps['status'] }) => {
  switch (status) {
    case GiftStatus.ACCEPTED:
      return (
        <Badge variant="light" color="blue" size="md" radius="sm" w="fit-content">
          수락 완료
        </Badge>
      );
    case GiftStatus.REFUNDED:
      return (
        <Badge variant="filled" color="gray" size="md" radius="sm" w="fit-content">
          선물 취소
        </Badge>
      );
    case GiftStatus.PENDING:
      return (
        <Badge variant="light" color="orange" size="md" radius="sm" w="fit-content">
          수락 전
        </Badge>
      );
    default:
      return null;
  }
};

export function ReceivedGiftItem({ item }: { item: ReceivedGiftItemProps }) {
  return (
    <Stack spacing={8}>
      <GiftItemHeader dateLabel="받은 날짜" date={item.receivedDate} href={item.detailURL} />

      <Box
        p={16}
        css={{
          border: `1px solid ${COLOR_PALETTE.gray[2]}`,
          borderRadius: '8px',
        }}
      >
        <Stack spacing={8}>
          <StatusBadge status={item.status} />

          <Group spacing={48} align="flex-start">
            <Stack spacing={4} css={{ flex: 1 }}>
              <GiftInfoRow
                label="선물 받은 강의"
                value={
                  <Ellipsis lineClamp={1}>
                    <Anchor
                      href={item.courseDetailURL}
                      size="sm"
                      color="dark"
                      weight={600}
                      target="_blank"
                    >
                      {item.courseTitle}
                    </Anchor>
                  </Ellipsis>
                }
              />
              <GiftInfoRow label="선물 보낸 분" value={item.senderName} />
              <GiftInfoRow
                label={item.status === GiftStatus.REFUNDED ? '취소 일시' : '수강 안내'}
                value={
                  <Stack spacing={2} css={{ flex: 1 }}>
                    {item.courseDescription01 ? item.courseDescription01 : null}
                    {item.courseDescription02 ? item.courseDescription02 : null}
                  </Stack>
                }
              />
            </Stack>

            <Box
              w={94}
              h={96}
              maw={94}
              mah={94}
              css={{
                img: {
                  width: 94,
                },
                [desktopFirstMediaQuery.mobile]: {
                  display: 'none',
                },
              }}
            >
              <OptimizeImage
                src={item.courseImageUrl}
                alt="강의 이미지"
                css={{
                  borderRadius: 12,
                }}
                w={94}
              />
            </Box>
          </Group>
        </Stack>
      </Box>
    </Stack>
  );
}
